export enum TimeTransactionEnum {
  TimeTransaction = 'timeTransactions'
}

export enum TimeTransactionEnumApi {
  timeTransaction = 'timeTransactions/'
}
